/**
 * Created by mac-mini3 on 15/06/17.
 */
import { NativeDateAdapter } from '@angular/material';

export class AppSettings {
  //public static API_STARTPOINT = 'http://localhost:1003/NisscoV2';
  //public static API_STARTPOINT = 'http://192.168.1.50:8888/NisscoV2_bk';
  //public static API_STARTPOINT = 'http://192.168.1.104/NisscoV2';
  //public static API_STARTPOINT = 'https://events.nissco.com/demo/api';
  public static API_STARTPOINT = 'https://events.nissco.com/api';


    public static CONTACT_EMAIL = 'conference@nissco.com';
    public static CONTACT_NAME = 'Open House Regional Event';
}

export const MY_DATE_FORMATS = {
  parse: {
    dateInput: null,
  },
  display: {
    dateInput: { year: 'numeric', month: 'numeric', day: 'numeric' },
    monthYearLabel: { year: 'numeric', month: 'short' },
    dateA11yLabel: { year: 'numeric', month: 'long', day: 'numeric' },
    monthYearA11yLabel: { year: 'numeric', month: 'long' },
  }
}

export class MyDateAdapter extends NativeDateAdapter {
  format(date: Date, displayFormat: Object): string {
    let day = date.getDate();
    let month = date.getMonth() + 1;
    let year = date.getFullYear();
    return this._to2digit(month) + '/' + this._to2digit(day) + '/' + year;
    /*if (displayFormat == "input") {
     let day = date.getDate();
     let month = date.getMonth() + 1;
     let year = date.getFullYear();
     return this._to2digit(day) + '/' + this._to2digit(month) + '/' + year;
     } else {
     return date.toDateString();
     }*/
  }

  private _to2digit(n: number) {
    return ('00' + n).slice(-2);
  }
}



// WEBPACK FOOTER //
// /var/www/html/nissco_event_web/angular/src/app/app-settings.ts